import type {
  ClassroomMentorClassResource,
  ClassroomModulesResource,
} from "api/generated";
import type { ClassroomMentorClass, ClassroomModules } from "classroom/types";

const mapMentorClassModules = (
  modules: ClassroomModulesResource,
): ClassroomModules => ({
  portfolio: modules.portfolio,
  meetings: modules.meetings,
  learning_goals: modules.learning_goals,
  conversations: modules.conversations,
});

export const mentorClassFromDto = (
  resource: ClassroomMentorClassResource,
): ClassroomMentorClass => ({
  name: resource.name,
  mentors: resource.mentors,
  modules: mapMentorClassModules(resource.modules),
});
